import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InterviewCoach from "./pages/InterviewCoach";

const Home = () => {
  return <InterviewCoach />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;